/**
 * Self-reactivation grace window. A member whose `deactivated_at` is non-null
 * remains able to authenticate (and reactivate themselves) for this long after
 * deactivation; past it, sessions fail to resolve and only an admin can re-open
 * the account. 30 days mirrors the standard reversibility window used by
 * LinkedIn / Twitter / Instagram and is the single source of truth shared by
 * the session loader, the self-reactivate route, and the client-side usability
 * check.
 */
export const SELF_REACTIVATE_WINDOW_MS = 30 * 24 * 60 * 60 * 1000;
//# sourceMappingURL=windows.js.map